import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, Clock, XCircle, AlertCircle } from 'lucide-react';

interface StatusCardsProps {
  stats: {
    pending_count: number;
    processing_count: number;
    completed_count: number;
    failed_count: number;
  } | null | undefined;
}

export const StatusCards = ({ stats }: StatusCardsProps) => {
  const cards = [
    {
      title: 'Pending',
      value: stats?.pending_count || 0,
      icon: Clock,
      color: 'text-yellow-600'
    },
    {
      title: 'Processing',
      value: stats?.processing_count || 0,
      icon: AlertCircle,
      color: 'text-blue-600'
    },
    {
      title: 'Completed',
      value: stats?.completed_count || 0,
      icon: CheckCircle,
      color: 'text-green-600'
    },
    {
      title: 'Failed',
      value: stats?.failed_count || 0,
      icon: XCircle,
      color: 'text-red-600'
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
            <card.icon className={`h-4 w-4 ${card.color}`} />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{card.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
